<ng-container *t="let t">
    <div class="row mx-0">
        <div class="col col-12">
            <h5 class="label" i18n="@@UploadDocumentAhead" t="UploadDocumentAhead">Upload Document:</h5>
            <tsl-file-drop [inputText]="translate.get('choose a file')" [hintText]="translate.get('Drag and Drop a File or ')" #fileDrop [multiple]="false" (fileChange)="onFileAdd($event)"></tsl-file-drop>
            <tsl-error *ngIf="errorMessage" class="text-left">{{ errorMessage }}</tsl-error>
        </div>
        <div class="col col-12">
            <button type="button" tsl-button color="black" outline (click)="closeDialog()" i18n="@@Close" t="Close"
                #closeButton
                i18n-tooltip="@@Close"
                tooltip="Close" 
                tslTooltip="{{ t('Close', closeButton) }}"
            >
                Close
            </button>
        </div>
    </div>
</ng-container>
